var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRouteAddWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "route-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416 320L320 320C302.4 320 288 305.6 288 288C288 270.4 302.4 256 320 256L416 256C416 256 512 149 512 96C512 43 469 0 416 0C363 0 320 43 320 96C320 121.5 342.2 159.4 365.3 192L320 192C267.1 192 224 235.1 224 288C224 340.9 267.1 384 320 384L416 384C433.6 384 448 398.4 448 416C448 433.6 433.6 448 416 448L185.5 448C169.5 472.8 151.7 495.7 138.2 512L416 512C468.9 512 512 468.9 512 416C512 363.1 468.9 320 416 320ZM416 64C433.7 64 448 78.3 448 96C448 113.7 433.7 128 416 128C398.3 128 384 113.7 384 96C384 78.3 398.3 64 416 64ZM96 256C43 256 0 299 0 352C0 405 96 512 96 512C96 512 192 405 192 352C192 299 149 256 96 256ZM96 384C78.3 384 64 369.7 64 352C64 334.3 78.3 320 96 320C113.7 320 128 334.3 128 352C128 369.7 113.7 384 96 384Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.857 66.7857L103.214 66.7857L103.214 12.1429C103.214 5.43772 97.7766 0 91.0714 0L78.9286 0C72.2234 0 66.7857 5.43772 66.7857 12.1429L66.7857 66.7857L12.1429 66.7857C5.43772 66.7857 0 72.2234 0 78.9286L0 91.0714C0 97.7766 5.43772 103.214 12.1429 103.214L66.7857 103.214L66.7857 157.857C66.7857 164.562 72.2234 170 78.9286 170L91.0714 170C97.7766 170 103.214 164.562 103.214 157.857L103.214 103.214L157.857 103.214C164.562 103.214 170 97.7766 170 91.0714L170 78.9286C170 72.2234 164.562 66.7857 157.857 66.7857L157.857 66.7857L157.857 66.7857Z",
    transform: "translate(25 25)",
    id: "plus",
    fill: "#FFFFFF",
    stroke: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRouteAddWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/route-add-white.ad46f0aeb841abbeb8785d633cb2ab34.svg";